var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security/eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3988 8.99991C12.3988 10.4849 11.1988 11.6849 9.71378 11.6849C8.22878 11.6849 7.02881 10.4849 7.02881 8.99991C7.02881 7.51491 8.22878 6.31494 9.71378 6.31494C11.1988 6.31494 12.3988 7.51491 12.3988 8.99991Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.71377 15.2026C12.3613 15.2026 14.8288 13.6426 16.5463 10.9426C17.2213 9.88506 17.2213 8.10756 16.5463 7.05004C14.8288 4.35004 12.3613 2.79004 9.71377 2.79004C7.06625 2.79004 4.59875 4.35004 2.88125 7.05004C2.20625 8.10756 2.20625 9.88506 2.88125 10.9426C4.59875 13.6426 7.06625 15.2026 9.71377 15.2026Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.962ce083fb8548ae117c97b383f7b756.svg";
export { ForwardRef as ReactComponent };